import { cx } from "../../lib/cx.js";
import { IconButton } from "../IconButton/IconButton.js";
import { LinkButton } from "../LinkButton/LinkButton.js";
/* empty css                  */
import { useLayoutEffect, useRef, useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/ActiveFilters/ActiveFilters.tsx
/**
* The filters in force, as chips that each remove their filter, and Clear all: under a
* filter bar (line-item search). Renders only its status region when there are no
* filters. The design is proposed.
*/
function ActiveFilters({ filters, onRemove, onClearAll, label = "Active filters", clearLabel = "Clear all", emptyFocusTarget, className, ...rest }) {
	const rootRef = useRef(null);
	const listRef = useRef(null);
	const [status, setStatus] = useState("");
	const pendingFocus = useRef(null);
	useLayoutEffect(() => {
		const pending = pendingFocus.current;
		if (pending === null) return;
		pendingFocus.current = null;
		if (pending === "empty" || filters.length === 0) {
			(emptyFocusTarget?.() ?? rootRef.current)?.focus();
			return;
		}
		(listRef.current?.querySelectorAll(".ds-active-filters__remove"))?.[Math.min(pending, filters.length - 1)]?.focus();
	}, [filters, emptyFocusTarget]);
	const remove = (filter, index) => {
		pendingFocus.current = filters.length === 1 ? "empty" : index;
		setStatus(`Filter removed: ${filter.label}`);
		onRemove(filter.id);
	};
	const clearAll = () => {
		pendingFocus.current = "empty";
		setStatus("All filters cleared");
		onClearAll();
	};
	return /* @__PURE__ */ jsxs("div", {
		ref: rootRef,
		tabIndex: -1,
		className: cx("ds-active-filters", className),
		...rest,
		children: [filters.length > 0 && /* @__PURE__ */ jsxs("div", {
			role: "group",
			"aria-label": label,
			className: "ds-active-filters__group",
			children: [/* @__PURE__ */ jsx("ul", {
				ref: listRef,
				className: "ds-active-filters__list",
				children: filters.map((filter, index) => /* @__PURE__ */ jsxs("li", {
					className: "ds-active-filters__chip",
					children: [/* @__PURE__ */ jsx("span", {
						className: "ds-active-filters__label",
						children: filter.label
					}), /* @__PURE__ */ jsx(IconButton, {
						className: "ds-active-filters__remove",
						icon: "x",
						size: "sm",
						"aria-label": `Remove filter ${filter.label}`,
						onClick: () => remove(filter, index)
					})]
				}, filter.id))
			}), filters.length > 1 && /* @__PURE__ */ jsx(LinkButton, {
				className: "ds-active-filters__clear",
				onClick: clearAll,
				children: clearLabel
			})]
		}), /* @__PURE__ */ jsx("span", {
			className: "ds-active-filters__status",
			role: "status",
			children: status
		})]
	});
}
//#endregion
export { ActiveFilters };

//# sourceMappingURL=ActiveFilters.js.map